import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ItemsListComponent } from './items/items-list/items-list.component';
// import { PopComponent } from './pop/pop/pop.component';
// import { PosComponent } from './pos/pos/pos.component';
// import { PurchaseComponent } from './purchase/purchase.component';
import { StatusComponent } from './status/status.component';
import { TestComponent } from './test/test.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { 
    path: 'dashboard', 
    component:DashboardComponent,
    canActivate: [AuthGuard]
  },
  { path: 'item-list', component: ItemsListComponent },
  { path: 'pos', loadChildren: () => import('./pos/pos.module').then(m => m.PosModule) },
  { path: 'purchase', loadChildren: () => import('./pop/pop.module').then(m => m.PopModule) },
  { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
  { path: 'test', component: TestComponent },
  { path: 'status', component: StatusComponent }
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
